export default "__VITE_ASSET__Dy2c0yM4__"